import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CreditCard, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import api, { formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function Pricing() {
  const { user, loading } = useAuth();
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!loading && user && user.subscription_status === "active") nav("/dashboard", { replace: true });
    if (!loading && !user) nav("/signup", { replace: true });
  }, [user, loading, nav]);

  const start = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/payments/checkout", { origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (e) { toast.error(formatError(e)); setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-6" data-testid="pricing-page">
      <div className="max-w-md w-full text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-slate-200 text-xs font-semibold text-slate-700">
          <span className="w-1.5 h-1.5 rounded-full bg-amber-500" /> Subscription required
        </div>
        <h1 className="font-display font-extrabold text-3xl mt-4">Activate Quick Quotes Pro</h1>
        <p className="text-sm text-slate-500 mt-2">Hi {user?.name?.split(" ")[0]} — your dashboard unlocks the moment payment goes through.</p>

        <div className="mt-8 rounded-xl border border-slate-200 shadow-xl shadow-slate-900/5 overflow-hidden text-left">
          <div className="bg-slate-900 text-white px-6 py-5">
            <div className="text-xs font-bold uppercase tracking-widest text-blue-300">Quick Quotes Pro</div>
            <div className="mt-2 flex items-baseline gap-1">
              <span className="font-display font-extrabold text-4xl">$3.99</span>
              <span className="text-slate-400 font-medium">/month</span>
            </div>
          </div>
          <div className="p-6">
            <Button onClick={start} disabled={busy} className="w-full h-12 bg-blue-600 hover:bg-blue-700 text-white font-bold" data-testid="start-sub-btn">
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <><CreditCard className="w-4 h-4 mr-2" /> Start for $3.99/Month</>}
            </Button>
            <p className="mt-3 text-[11px] text-center text-slate-500">Secure checkout by Stripe · Cancel anytime</p>
          </div>
        </div>
      </div>
    </div>
  );
}
